
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/resources/downloadables",
      function () {
        return require("private-next-pages/resources/downloadables.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/resources/downloadables"])
      });
    }
  